module.exports = __webpack_public_path__ + "img/help_upload.713f6f91.png";